var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"text-center mt-4 p-4"},[_c('h3',[_vm._v("Глава "+_vm._s(_vm.chapter.number))]),_c('p',{staticClass:"text-left",domProps:{"innerHTML":_vm._s(_vm.chapter.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }